import React from "react";
import { twMerge } from "tailwind-merge";
import { AdditionalServiceItem } from "@features/AdditionalServices/components/AdditionalServiceItem/AdditionalServiceItem";
import { AdditionalServiceSpecialItem } from "@features/AdditionalServices/components/AdditionalServiceSpecialItem/AdditionalServiceSpecialItem";
import { type IAdditionalService } from "@services/additional-services/types";
import { AdditionalServiceAdverts } from "../AdditionalServiceAdverts/AdditionalServiceAdverts";

export interface IAdditionalServicesListProps {
  services: IAdditionalService[];
  isOrderedPage?: boolean;
  returnPath?: string;
  limit?: boolean;
}

const IS_SPECIAL = false; // TODO: Filter special items from API model

export const AdditionalServicesList: React.FC<IAdditionalServicesListProps> = ({
  services,
  isOrderedPage,
  returnPath,
  limit,
}) => {
  return (
    <div
      className={twMerge(
        "grid grid-cols-[repeat(auto-fill,minmax(320px,1fr))] gap-6",
        limit && `[&>*:nth-child(n+4)]:hidden`,
      )}
    >
      <AdditionalServiceAdverts />
      {services.map((s) =>
        IS_SPECIAL && !isOrderedPage ? (
          <AdditionalServiceSpecialItem
            key={s.additionalServiceId}
            service={s}
            returnPath={returnPath}
          />
        ) : (
          <AdditionalServiceItem
            key={s.additionalServiceId}
            service={s}
            isOrderedPage={isOrderedPage}
            returnPath={returnPath}
          />
        ),
      )}
    </div>
  );
};
